// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"2bdce3d13ee9db3415e5","655":"3cb02ac2f1dd5c9282e8"}[chunkId] + ".js";
};